module.exports = __webpack_public_path__ + "img/snow.b156f7c3.svg";